<div *ngIf="loading" class="graph loading" id="dailyChurnRate" [chart]="dailyChurnRateChart"></div>
<div *ngIf="!loading" class="graph" id="dailyChurnRate" [chart]="dailyChurnRateChart"></div>